module.exports = __webpack_public_path__ + "static/media/galerija_2014 (29).c636b4f7.jpg";